export default __webpack_public_path__ + "static/img-credit-score-benefit-54e190791e4acdac8c29ec75c8aecd1d.webp";